/* unplugin-vue-components disabled */import { render } from "./FormSelect.vue?vue&type=template&id=55a048e6&ts=true"
import script from "./FormSelect.vue?vue&type=script&lang=ts"
export * from "./FormSelect.vue?vue&type=script&lang=ts"

import "./FormSelect.vue?vue&type=style&index=0&id=55a048e6&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__